import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import ReactMarkdown from 'react-markdown';
import { styled, useTheme } from '../../styles';
import { Subheader } from '../typography';
import { IconButton } from '../buttons';
import { Row } from '../layout';
import remarkGfm from 'remark-gfm';
const MAPPED_COMPONENTS = {
    div: ({ ...props }) => _jsx(ReactMarkdownDiv, { ...props }),
    h1: ({ ...props }) => _jsx(ReactMarkdownH1, { ...props }),
    h2: ({ ...props }) => _jsx(ReactMarkdownH2, { ...props }),
    h3: ({ ...props }) => _jsx(ReactMarkdownH3, { ...props }),
    h4: ({ ...props }) => _jsx(ReactMarkdownH4, { ...props }),
    h5: ({ ...props }) => _jsx(ReactMarkdownH5, { ...props }),
    h6: ({ ...props }) => _jsx(ReactMarkdownH6, { ...props }),
    ul: ({ ...props }) => _jsx(ReactMarkdownUL, { ...props }),
    ol: ({ ...props }) => _jsx(ReactMarkdownOL, { ...props }),
    p: ({ ...props }) => _jsx(ReactMarkdownP, { ...props }),
    span: () => _jsx(ReactMarkdownSpan, {}),
    strong: ({ ...props }) => _jsx(ReactMarkdownStrong, { ...props }),
    a: ({ ...props }) => {
        const linkWithBlankTarget = { ...props, target: '_blank' };
        return _jsx(ReactMarkdownA, { ...linkWithBlankTarget });
    },
    em: ({ ...props }) => _jsx(ReactMarkdownEM, { ...props }),
};
export const MarkDownNotes = ({ text, onEdit, showTitle, readOnly = false, editButtonStyles = {}, }) => {
    const theme = useTheme();
    return (_jsxs("div", { "data-testid": "markdown-call-notes-view", "data-clarity-mask": "true", children: [_jsxs(Header, { "data-clarity-unmask": "true", children: [showTitle && (_jsx(Subheader, { size: "mediumLarge", "data-testid": "call-notes-heading", children: "Call Notes" })), !readOnly && (_jsx(IconButton, { iconName: "EditIcon", name: "editNotes", label: "Edit Notes", onClick: onEdit, style: {
                            marginLeft: 'auto',
                            color: theme.colors.grey50,
                            ...editButtonStyles,
                        }, "data-testid": "edit-notes-icon" }))] }), _jsx(Markdown, { text: text })] }));
};
export const Markdown = ({ text }) => {
    return (_jsx(ReactMarkdown, { components: MAPPED_COMPONENTS, remarkPlugins: [remarkGfm], children: text }));
};
const Header = styled(Row)({
    padding: '3px',
    textAlign: 'left',
});
const ReactMarkdownDiv = styled.div({
    textAlign: 'left',
});
const ReactMarkdownH1 = styled.h1(({ theme }) => ({
    fontWeight: 'bolder',
    fontSize: '22px',
    color: theme.colors.grey80,
    fontFamily: 'Poppins',
    overflowWrap: 'break-word',
}));
const ReactMarkdownH2 = styled.h2(({ theme }) => ({
    fontWeight: 'bolder',
    fontSize: '20px',
    color: theme.colors.grey80,
    fontFamily: 'Poppins',
    overflowWrap: 'anywhere',
}));
const ReactMarkdownH3 = styled.h3(({ theme }) => ({
    fontWeight: 'bolder',
    fontSize: '18px',
    color: theme.colors.grey80,
    fontFamily: 'Poppins',
    overflowWrap: 'break-word',
}));
const ReactMarkdownH4 = styled.h4(({ theme }) => ({
    fontWeight: 'bolder',
    fontSize: '16px',
    color: theme.colors.grey80,
    fontFamily: 'Poppins',
    overflowWrap: 'break-word',
}));
const ReactMarkdownH5 = styled.h5(({ theme }) => ({
    fontWeight: 'bolder',
    fontSize: '14px',
    color: theme.colors.grey80,
    fontFamily: 'Poppins',
    overflowWrap: 'break-word',
}));
const ReactMarkdownH6 = styled.h6(({ theme }) => ({
    fontWeight: 'bold',
    fontSize: '13px',
    color: theme.colors.grey80,
    fontFamily: 'Poppins',
    overflowWrap: 'break-word',
}));
const ReactMarkdownUL = styled('ul')({
    marginTop: '1em',
    marginBottom: '1em',
    marginLeft: '2em',
    listStyle: 'circle outside none',
});
const ReactMarkdownOL = styled('ol')({
    marginTop: '1em',
    marginBottom: '1em',
    marginLeft: '2em',
    listStyleType: 'decimal',
});
const ReactMarkdownSpan = styled.span(({ theme }) => ({
    color: theme.colors.grey90,
    fontFamily: 'ASAP',
    fontSize: '16px',
    lineHeight: '1.5',
}));
const ReactMarkdownP = styled.p(({ theme }) => ({
    display: 'block',
    color: theme.colors.grey90,
    fontFamily: 'ASAP',
    fontSize: '16px',
    lineHeight: '1.5',
    overflowWrap: 'anywhere',
}));
const ReactMarkdownStrong = styled.strong(({ theme }) => ({
    fontWeight: 600,
    fontFamily: 'ASAP',
    fontSize: '16px',
    color: theme.colors.grey90,
}));
const ReactMarkdownA = styled.a(({ theme }) => ({
    color: theme.colors.blue50,
    fontFamily: 'Poppins',
    fontSize: '16px',
    textDecoration: 'none',
    fontWeight: 600,
    overflowWrap: 'break-word',
    ':hover': {
        color: theme.colors.blue40,
    },
}));
const ReactMarkdownEM = styled.em(({ theme }) => ({
    fontFamily: 'ASAP',
    fontStyle: 'italic',
    color: theme.colors.grey90,
}));
//# sourceMappingURL=markdown_notes.js.map